import React from "react";
import { Spinner } from "../UI/States";

// Shared loading indicator. Used both for whole-page loads and inside small
// slots (footer, header weather), so it sizes to its container with a modest
// minimum instead of claiming the full viewport height.
const LoadingSpinner = ({ label }) => {
  return (
    <div className="flex h-full min-h-[6rem] w-full flex-col items-center justify-center gap-3 py-6">
      <Spinner />
      {label && <p className="app-muted text-sm">{label}</p>}
    </div>
  );
};

export default LoadingSpinner;
